import { useCallback, useMemo, useState } from "react";
import styles from "./match-editor.module.css"
import { MatchBeatsWidget } from "./MatchBeatsWidget/MatchBeatsWidget";
import { DoubleMatchRecord } from "pages/tests/libs/match-record/MatchRecord";
import { AD } from "pages/tests/libs/match-record/action-record/constants";

type TArgMatchEditor = {
    matchData: any;
    onClose: () => void;
    setPoints: (matchbeats: any[]) => void
}

const GAME = 100
const BREAKPOINT = 300
const DOUBLE_FAULTS = 2
const ACE = 1

export const MatchEditor = ({
    matchData,
    onClose,
    setPoints
}: TArgMatchEditor): JSX.Element => {
    const [hold, setHold] = useState<0|1|undefined>(undefined)
    const [newBeatsMatch, setNewBeatsMatch] = useState<any[]>([{
        opponents: [
            ...matchData.team1Names.map((team: any) => {return {name: team.name}}),
            ...matchData.team2Names.map((team: any) => {return {name: team.name}}),
        ],
        data: [],
        setName: 'Set 1'
    }])

    const Pointer = useCallback((point: 0|1, state?: 300 | 2 | 1) => {
        const newBeats: any = [...newBeatsMatch]
        if (newBeats.length < 1) {
            return
        }
        if (hold === undefined) {
            return
        }


        // Крайний сет
        const lastData = newBeats.at(-1)?.data

        // Проверка на кол-во геймов
        if(lastData.length === 0) {
            newBeats.at(-1).data.push(
                {
                    holds: hold + 1,
                    isTieBreak: false,
                    results: {
                        holds: hold + 1,
                        setScore: [0, 0],
                        winner: 0,
                        time: "00:00"
                    },
                    scores: [
                        [
                            point === 0 ? "15" : "0",
                            point === 1 ? "15" : "0",
                            point === 0 ? true : false,
                            point === 1 ? true : false,
                            ...(state === 2 ? (point === 0 ? [false, 2] : [2, false]) : []),
                            ...(state === 1 ? (point === 0 ? [1, false] : [false, 1]) : [])
                        ]
                    ]
                }
            )

            setNewBeatsMatch(newBeats)
            return
        }

        // Крайний счет в последнем гейме
        const lastScores = lastData.at(-1)?.scores.at(-1)

        if (lastScores.includes('Game')) {
            if (
                lastData.at(-1)?.results.setScore.at(0) === 6
             && lastData.at(-1)?.results.setScore.at(1) === 6
            ) {
                //isTieBreak
                newBeats.at(-1).data.push(
                    {
                        holds: hold + 1,
                        isTieBreak: true,
                        results: {
                            holds: hold + 1,
                            setScore: lastData.at(-1).results.setScore,
                            winner: 0,
                            time: "00:00"
                        },
                        scores: [
                            [
                                point === 0 ? "1" : "0",
                                point === 1 ? "1" : "0",
                                point === 0 ? true : false,
                                point === 1 ? true : false,
                                ...(state === 2 ? (point === 0 ? [false, 2] : [2, false]) : []),
                                ...(state === 1 ? (point === 0 ? [1, false] : [false, 1]) : [])
                            ]
                        ]
                    }
                )
            } else {
                newBeats.at(-1).data.push(
                    {
                        holds: hold + 1,
                        isTieBreak: false,
                        results: {
                            holds: hold + 1,
                            setScore: lastData.at(-1).results.setScore,
                            winner: 0,
                            time: "00:00"
                        },
                        scores: [
                            [
                                point === 0 ? "15" : "0",
                                point === 1 ? "15" : "0",
                                point === 0 ? true : false,
                                point === 1 ? true : false,
                                ...(state === 2 ? (point === 0 ? [false, 2] : [2, false]) : []),
                                ...(state === 1 ? (point === 0 ? [1, false] : [false, 1]) : [])
                            ]
                        ]
                    }
                )
            }


            setNewBeatsMatch(newBeats)
            return
        }


        const score = (): string[] => {
            const points = ["15", "30", "40"] //AD Game
            const isTieBreakPoints = ["1", "2", "3", "4", "5", "6"] //Game
            const catcher = point === 0 ? 1 : 0

            if (lastScores[point] === "40") {

                if (lastScores[catcher] === "40") {
                    return [
                        point === 0 ? "AD" : lastScores[catcher],
                        point === 1 ? "AD" : lastScores[catcher]
                    ]
                }

                if (lastScores[catcher] === "AD") {
                    return [
                        "40",
                        "40"
                    ]
                }

                lastData.at(-1).results = {
                    ...lastData.at(-1).results,
                    winner: point + 1,
                    setScore: [
                        point === 0 ? lastData.at(-1).results.setScore[0] + 1 : lastData.at(-1).results.setScore[0],
                        point === 1 ? lastData.at(-1).results.setScore[1] + 1 : lastData.at(-1).results.setScore[1]
                    ]
                }
                setHold(hold ? 0 : 1)

                return [
                    point === 0 ? "Game" : lastScores[catcher],
                    point === 1 ? "Game" : lastScores[catcher]
                ]
            }

            if (lastScores[point] === "AD") {

                setHold(hold ? 0 : 1)
                lastData.at(-1).results = {
                    ...lastData.at(-1).results,
                    winner: point + 1,
                    setScore: [
                        point === 0 ? lastData.at(-1).results.setScore[0] + 1 : lastData.at(-1).results.setScore[0],
                        point === 1 ? lastData.at(-1).results.setScore[1] + 1 : lastData.at(-1).results.setScore[1]
                    ]
                }

                return [
                    point === 0 ? "Game" : lastScores[catcher],
                    point === 1 ? "Game" : lastScores[catcher]
                ]
            }

            if (lastData.at(-1)?.isTieBreak && lastScores[point] === "6") {
                setHold(hold ? 0 : 1)
                lastData.at(-1).results = {
                    ...lastData.at(-1).results,
                    winner: point + 1,
                    setScore: [
                        point === 0 ? lastData.at(-1).results.setScore[0] + 1 : lastData.at(-1).results.setScore[0],
                        point === 1 ? lastData.at(-1).results.setScore[1] + 1 : lastData.at(-1).results.setScore[1]
                    ]
                }

                return [
                    point === 0 ? "Game" : lastScores[catcher],
                    point === 1 ? "Game" : lastScores[catcher]
                ]
            }


            if (lastData.at(-1)?.isTieBreak) {
                return [
                    point === 0 ? isTieBreakPoints[isTieBreakPoints.indexOf(lastScores[point]) + 1] : lastScores[catcher],
                    point === 1 ? isTieBreakPoints[isTieBreakPoints.indexOf(lastScores[point]) + 1] : lastScores[catcher]
                ]
            } else {
                return [
                    point === 0 ? points[points.indexOf(lastScores[point]) + 1] : lastScores[catcher],
                    point === 1 ? points[points.indexOf(lastScores[point]) + 1] : lastScores[catcher]
                ]
            }
        }

        const scoreFinal = score()

        lastData.at(-1).scores.push(
            [
                ...scoreFinal,
                point === 0 ? true : false,
                point === 1 ? true : false,
                ...(state === 2 ? (point === 0 ? [false, 2] : [2, false]) : []),
                ...(state === 1 ? (point === 0 ? [1, false] : [false, 1]) : [])
            ]
        )        
        
        
        const lastResultsScores = lastData.at(-1)?.results.setScore

        if (scoreFinal.includes('Game') && (lastResultsScores.at(0) > 5 || lastResultsScores.at(1) > 5)) {
            if (
                lastResultsScores.at(0) - lastResultsScores.at(1) > 1
             || lastResultsScores.at(1) - lastResultsScores.at(0) > 1
            ) {
                newBeats.push({
                    opponents: [
                        ...matchData.team1Names.map((team: any) => {return {name: team.name}}),
                        ...matchData.team2Names.map((team: any) => {return {name: team.name}}),
                    ],
                    data: [],
                    setName: `Set ${newBeats.length + 1}`
                })
            }
        }

        setNewBeatsMatch(newBeats)
    }, [hold, newBeatsMatch])

    const setTimeGame = (set: number, game: number, time: string) => {

        const redBeatsMatch = [...newBeatsMatch]

        redBeatsMatch.at(set).data.at(game).results.time = time

        setNewBeatsMatch(redBeatsMatch)
    }

    const onUpdateBeats = useCallback(() => {
        setPoints(newBeatsMatch)
        onClose()
    }, [newBeatsMatch])

    const onCopy = () => {
        if (matchData.matchbeats.length === 0) {
            return
        }

        setNewBeatsMatch(matchData.matchbeats)
        setHold(lastHold(matchData.matchbeats))
    }

    const onBackSpace = () => {
        const redBeatsMatch = structuredClone(newBeatsMatch)
        if (redBeatsMatch.length === 0) {
            return
        }

        if (redBeatsMatch.at(-1).data.length === 0) {
            return
        }


        redBeatsMatch.at(-1).data.at(-1).scores.pop()
        
        if (redBeatsMatch.at(-1).data.at(-1).scores.length === 0) {
            redBeatsMatch.at(-1).data.pop()
        }

        if (redBeatsMatch.at(-1).data.length === 0) {
            redBeatsMatch.pop()
        }

        setHold(lastHold(redBeatsMatch))

        if (redBeatsMatch.length === 0) {
            redBeatsMatch.push({
                opponents: [
                    ...matchData.team1Names.map((team: any) => {return {name: team.name}}),
                    ...matchData.team2Names.map((team: any) => {return {name: team.name}}),
                ],
                data: [],
                setName: 'Set 1'
            })

            setHold(undefined)
        }
           
        setNewBeatsMatch(redBeatsMatch)
    }

    const lastHold = (matchbeats: any[]): undefined | 0 | 1 => {
        const lastSet = matchbeats.at(-1)
        if (!lastSet) {
            return undefined
        }

        const filterGame = lastSet.data.filter((game: any) => game.holds !== 0)
        if (filterGame.length === 0) {
            return undefined
        }

        const filterHold: 1|2 = filterGame.at(-1).holds
        if (filterGame.at(-1).scores.at(-1).includes('Game')) {
            return (filterHold - 1) as 0 | 1 === 0 ? 1: 0;
        }

        return (filterHold - 1) as 0 | 1;
    }

    return (
        <div className={styles.App}>
            <div className={styles.WindowEditor}>
                <div className={styles.Close} onClick={onClose}>Назад</div>

                <MatchBeatsWidget beats={matchData.matchbeats} autoScroll={false} />
                <MatchBeatsWidget beats={newBeatsMatch} autoScroll={true} timeRedaction={setTimeGame} />

                {hold === undefined && <div className={styles.ControlBar}>
                    <div className={styles.Control} onClick={() => setHold(0)}>Подает первый игрок</div>
                    <div className={styles.Control} onClick={() => setHold(1)}>Подает второй игрок</div>
                </div>}
                
                {hold !== undefined && <>
                    <div className={styles.ControlBar}>
                        <div className={styles.Control} onClick={() => Pointer(0)}>Очко первому игроку</div>
                        <div className={styles.Control} onClick={() => Pointer(1)}>Очко второму игроку</div>
                    </div>
                    {/* <div className={styles.ControlBar}>
                        <div className={styles.Control} onClick={() => Pointer(0, 300)}>Break Point первому игроку</div>
                        <div className={styles.Control} onClick={() => Pointer(1, 300)}>Break Point второму игроку</div>
                    </div> */}
                    <div className={styles.ControlBar}>
                        <div className={styles.Control} onClick={() => Pointer(1, 2)}>Double Fault первому игроку</div>
                        <div className={styles.Control} onClick={() => Pointer(0, 2)}>Double Fault второму игроку</div>
                    </div>
                    <div className={styles.ControlBar}>
                        <div className={styles.Control} onClick={() => Pointer(0, 1)}>Aces первому игроку</div>
                        <div className={styles.Control} onClick={() => Pointer(1, 1)}>Aces второму игроку</div>
                    </div>
                </>}

                <div className={styles.ControlBar}>
                    <div className={styles.Control} onClick={() => onCopy()}>Copy</div>
                    <div className={styles.Control} onClick={() => onBackSpace()}>BackSpace</div>
                    <div className={styles.Control} onClick={() => onUpdateBeats()}>Принять</div>
                </div>
            </div>
        </div>
    )
}